"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";

import {
  AUTH_HELP_PANEL_LINK_CLASSES,
  AuthHelpPanel,
} from "@/app/(discover)/components/auth/auth-help-panel";
import { appendQuery } from "@/app/(hire)/lib/return-to";
import { formMode } from "@/components/auth/form-mode";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import routes from "@/lib/routes";

const PANEL_COPY = {
  [formMode.signin]:
    "This is the job-seeker sign-in. District staff sign in to their hiring tools with a work email. There is no admin sign-up.",
  [formMode.signup]:
    "This page creates a job-seeker account. Your district creates your admin account. There is no admin sign-up.",
} as const;

interface HiringPanelProps {
  mode: formMode;
  query: string;
}

export function HiringPanel({ mode, query }: HiringPanelProps) {
  return (
    <AuthHelpPanel
      title="Hiring for a school or district?"
      triggerTestId={authTestIds.HIRING_PANEL_TRIGGER}
      contentTestId={authTestIds.HIRING_PANEL_CONTENT}
    >
      <p>{PANEL_COPY[mode]}</p>
      <Link
        href={appendQuery(routes.getHireSignIn(), query)}
        className={AUTH_HELP_PANEL_LINK_CLASSES}
      >
        Sign in to your district&apos;s hiring tools
        <ArrowRight className="size-3.5" aria-hidden="true" />
      </Link>
    </AuthHelpPanel>
  );
}
